// extracted by mini-css-extract-plugin
module.exports = {"handUpList":"style_handUpList__W9_CB"};